<template>
  <div class="page landing">
    <section class="content">
      <img src="https://static.ndmicro.com/tmd/landing/yzd/images/icon_04@2x.png" class="banner">
      <div class="box">
        <div class="text">
          <img src="https://static.ndmicro.com/tmd/landing/yzd/images/icon_05@2x.gif" alt="" class="text-img">
          关注天美贷公众号，直接提现
        </div>
        <div class="info">
          <div class="info-code">
            <img src="https://static.ndmicro.com/tmd/landing/yzd/images/img_QR@2x.png" class="code-img">
            <p class="code-text">天美贷公众号</p>
          </div>
          <div class="info-ctrl">
            <div class="ctrl-info info-download" @click="handleDownload">
              <h5 class="info-h">点击下载二维码至相册</h5>
              <p class="info-p">微信扫一扫识别关注公众号</p>
            </div>
            <div class="ctrl-info info-copy" @click="copy">
              <h5 class="info-h">点击复制微信号   ct_tmd</h5>
              <p class="info-p">微信搜索关注公众号</p>
            </div>
          </div>
        </div>
      </div>
      <div class="per-list">
        <div class="item">
          <img src="https://static.ndmicro.com/tmd/landing/yzd/images/icon_01@2x.png" class="item-img">
          <h5 class="item-h">快速审批</h5>
          <p class="item-p">最快5分钟放款</p>
        </div>
        <div class="item">
          <img src="https://static.ndmicro.com/tmd/landing/yzd/images/icon_02@2x.png" class="item-img">
          <h5 class="item-h">分期偿还</h5>
          <p class="item-p">可分12期偿还</p>
        </div>
        <div class="item">
          <img src="https://static.ndmicro.com/tmd/landing/yzd/images/icon_03@2x.png" class="item-img">
          <h5 class="item-h">放心使用</h5>
          <p class="item-p">正规持牌机构</p>
        </div>
      </div>
    </section>
    <section class="bottom">
      <p class="bottom-p">贷款额度，放款时间，还款方式，还款期限等以实际审批结果为准</p>
      <p class="bottom-p">（综合年化利率区间12%-24%，单利计算）</p>
      <p class="bottom-p">贷款有风险，请根据个人能力合理贷款，理性消费，避免逾期</p>
      <h4 class="bottom-h">崇天客服热线：400-010-0008</h4>
      <p class="bottom-p">重庆市崇天小额贷款有限公司</p>
      <p class="bottom-p">公司地址：重庆市南岸区南滨路22号1栋长江国际大厦33层3319室</p>
      <p class="bottom-p">渝公网安备 50010802002638号I渝ICP备18009772号-1</p>
      <div class="bottom-btn" v-stat="{id: 10299, args: {screen: 'page_landing_yzd'}}" @click="downloadApp">下载{{isIOS ? '天美钱包' : '天美贷'}}立即借款</div>
    </section>
    <download-cover v-if="isShowMask" />
    <ios-download v-model="downloadVisible"></ios-download>
    <ios-wxmp-dialog v-model="iosWxmpQRCodeDialogVisible"></ios-wxmp-dialog>
    <ios-wxmp-link-dialog v-model="iosWxmpLinkDialogVisible"></ios-wxmp-link-dialog>
    <web-clip-pop v-model="webclipPopVisible" @onClose="webclipPopVisible=false"/>
    <web-clip-copy-pop v-model="copyPopVisible" @onClose="copyPopVisible=false"/>
  </div>
</template>

<script>
import { copyToClipbord, judgeClientSystem } from '../../../assets/utils'
import { hasNativeMethod, jsBridge } from '@/assets/jsBridge'
import DownloadCover from '@/components/download-cover'
import IosDownload from '@/components/ios-download'
import IosWxmpDialog from '@/components/ios-wxmp-qrcode-dialog'
import IosWxmpLinkDialog from '@/components/ios-wxmp-link-dialog'
import WebClipPop from '../components/web-clip-pop.vue'
import WebClipCopyPop from '../components/web-clip-copy-pop.vue'
import DownloadQuestion from '../components/downloadQuestion.vue'
export default {
  components: {
    DownloadCover,
    IosDownload,
    WebClipPop,
    WebClipCopyPop,
    IosWxmpDialog,
    IosWxmpLinkDialog,
    DownloadQuestion
  },
  data () {
    return {
      isIOS: judgeClientSystem() === 'IOS'
    }
  },
  created () {
    this.$bus.$emit('ready')
  },
  methods: {
    copy () {
      copyToClipbord('ct_tmd')
      this.$message('已复制到剪贴板')
    },

    handleDownload () {
      this.downloadIamge('http://ndmicro-tmd.oss-cn-beijing.aliyuncs.com/authenticate/1_15683410918_Web_1605512702096', 'qrcode')
    },

    async downloadIamge (imgsrc, name) {
      this.$report({
        id: 10299,
        args: {
          screen: 'page_landing_yzd'
        }
      })
      if (hasNativeMethod('saveQRCode')) {
        const res = await jsBridge('saveQRCode', {
          url: imgsrc,
          name: name
        })
        if (res && res.code === 'OK') {
          this.saveSuccess()
        }
      } else if (this.isIOS) {
        this.$message('请长按左侧二维码保存')
      } else {
        let image = new Image()
        let self = this
        image.setAttribute('crossOrigin', 'anonymous')
        image.onload = function () {
          let canvas = document.createElement('canvas')
          canvas.width = image.width
          canvas.height = image.height
          let context = canvas.getContext('2d')
          context.drawImage(image, 0, 0, image.width, image.height)
          let url = canvas.toDataURL('image/png') // 得到图片的base64编码数据
          let a = document.createElement('a') // 生成一个a元素
          let event = new MouseEvent('click') // 创建一个单击事件
          a.download = name // 设置图片名称没有设置则为默认
          a.href = url // 将生成的URL设置为a.href属性
          a.dispatchEvent(event) // 触发a的单击事件
          self.saveSuccess()
        }
        image.src = imgsrc
      }
    },

    saveSuccess () {
      this.$message('已保存至系统相册')
    }
  }
}
</script>

<style lang="less" scoped>
@import "../../../assets/less/mixin.less";

.landing{
  .content{
    background: url(https://static.ndmicro.com/tmd/landing/yzd/images/img_chenggonglv@2x.png) top center no-repeat;
    background-size: 100%;
    height: 1562px;
    .banner{
      width: 584px;
      height: 66px;
      margin-top: 35px;
      margin-left: 40px;
    }
    .box{
      width: 670px;
      margin: 820px auto 0;
      border: 1px solid #FFC370;
      background-color: #F9DEB5;
      padding: 34px 30px;
      border-radius: 8px;
      .text{
        background: linear-gradient(162deg, rgba(196, 121, 58, 0.71) 0%, rgba(164, 80, 35, 0.74) 100%);
        height: 94px;
        display: flex;
        align-items: center;
        justify-content: center;
        font-size: 30px;
        color: #fff;
        font-weight: 500;
        .text-img{
          width: 67px;
          height: 42px;
          margin-right: 10px;
        }
      }
      .info{
        display: flex;
        justify-content: space-between;
        margin-top: 20px;
        .info-code{
          background-color: #fff;
          border-radius: 8px;
          padding: 10px 10px 6px;
          .code-img{
            width: 140px;
            height: 140px;
          }
          .code-text{
            font-size: 20px;
            margin-top: 4px;
            color: #333333;
            text-align: center;
          }
        }
        .info-ctrl{
          display: flex;
          flex-direction: column;
          justify-content: space-between;
          .ctrl-info{
            background-color: #fff;
            background-size: 30px;
            background-repeat: no-repeat;
            background-position: calc(100% - 20px) center;
            padding: 10px 30px;
            border-radius: 8px;
            width: 433px;
            .info-h{
              font-size: 26px;
              color: #333333;
              font-weight: 500;
            }
            .info-p{
              font-size: 20px;
              color: #9C9C9C;
            }
            &.info-download{
              background-image: url(https://static.ndmicro.com/tmd/landing/yzd/images/icon_download@2x.png);
            }
            &.info-copy{
              background-image: url(https://static.ndmicro.com/tmd/landing/yzd/images/icon_copy@2x.png);
            }
          }
        }
      }
    }
    .per-list{
      display: flex;
      justify-content: space-between;
      padding: 0 55px;
      margin-top: 90px;
      .item{
        display: flex;
        flex-direction: column;
        align-items: center;
        .item-img{
          width: 90px;
          height: 90px;
        }
        .item-h{
          margin-top: 18px;
          color: #333333;
          font-size: 28px;
          font-weight: 500;
        }
        .item-p{
          font-size: 24px;
          color: #999999;
        }
      }
    }
  }
  .bottom{
    color: #D0BFB0;
    background-color: #FFFAF5;
    padding: 24px 50px 80px;
    margin-top: 50px;
    .bottom-p{
      font-size: 20px;
      line-height: 28px;
    }
    .bottom-h{
      font-size: 32px;
      margin-top: 25px;
      margin-bottom: 5px;
      line-height: 45px;
      background: url(https://static.ndmicro.com/tmd/landing/yzd/images/icon_phone@2x.png) left center no-repeat;
      background-size: 32px;
      padding-left: 40px;
    }
    .bottom-btn{
      width: 520px;
      height: 94px;
      line-height: 94px;
      text-align: center;
      border-radius: 47px;
      background: linear-gradient(90deg, #FF3333 0%, #FF5F34 100%);
      color: #fff;
      font-weight: 500;
      font-size: 36px;
      margin: 80px auto 0;
      animation: rotate 1s linear infinite;
    }
    @keyframes rotate {
      0% {
        transform: scale(1);
      }
      50% {
        transform: scale(0.9);
      }
      100% {
        transform: scale(1);
      }
    }
  }
}
</style>